import { useEffect, useRef } from "react";

import { useImportAppointmentMutation } from "components/NavBarSearchAppointments/components/SearchDropdown/hooks";

type SearchDropdownProp = {
  onSelect: (id: string) => void;
  onClose: () => void;
};

export const useSearchDropdown = ({ onClose, onSelect }: SearchDropdownProp) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = ({ target }: MouseEvent) => {
      if (!(target instanceof HTMLElement)) return;

      const isSearchInput = target.id === "NavBarSearchInput";
      const isSearchIcon = target.closest(".search-icon") !== null;
      const isInsideDropdown = dropdownRef.current?.contains(target);

      if (!isInsideDropdown && !isSearchInput && !isSearchIcon) onClose();
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const { mutate: importAppointment, isPending: isImportAppointmentPending } = useImportAppointmentMutation(onSelect);

  return { dropdownRef, importAppointment, isImportAppointmentPending };
};
